module.exports = __webpack_public_path__ + "img/softPedestal.60e761dd.png";